import { render } from "./series-popup.vue?vue&type=template&id=c23216e0"
import script from "./series-popup.vue?vue&type=script&lang=js"
export * from "./series-popup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__